import React, { useState, useContext, useEffect, } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import '../styles/SearchResult.css';
import { APIBaseLink } from '../components/APIBaseLink';

// 
const SearchResult = ({ result, index }) => {
  const [selected, setSelected] = useState(false);
  const { setUserId, userId } = '';
  const { selectedResources, addSelectedResource, removeSelectedResource } = useContext(AuthContext);
  const { user, updateUserFavorites, isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isFavorited, setIsFavorited] = useState(false);
  const API_BASE_LINK = APIBaseLink();

  // Set initial checkbox state based on global selectedResources
  useEffect(() => {
    const isAlreadySelected = selectedResources.some(resource => resource._id === result._id);
    setSelected(isAlreadySelected);
  }, [selectedResources, result._id]);

  // Helper function to check if a field is valid (not "N/A", "NA", or empty string)
  const isValidField = (field) => {
    return typeof field === 'string' && field.toLowerCase() !== "n/a" && field.toLowerCase() !== "na" && field.trim() !== '';
  };

  //console.log("User id from AuthContext: " + user.id);
  //console.log("User._id is: " + localStorage.getItem('user._id'));

  // Fetch user's saved resources and check if the current one is favorited
  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        if (user?.id) {
          const response = await fetch(`${API_BASE_LINK}/user/getSaved?userId=${user.id}`);
          const data = await response.json();

          if (response.ok && data.resources) {
            // Check if the current resource is in the saved list
            setIsFavorited(data.resources.some(resource => resource._id === result._id));
          }
        }
      } catch (error) {
        console.error("Error fetching saved resources:", error);
      }
    };

    fetchFavorites();
  }, [result._id, user?.id]);

  // Function to handle checkbox click
  const handleCheckboxChange = (e) => {
    e.stopPropagation(); // Prevent triggering card click event
    if (selected) {
      removeSelectedResource(result._id);
    } else {
      addSelectedResource(result);
    }
    setSelected(!selected);
  };
  
  // Inputs: Is the user logged in?
  // Output: If Yes, then toggles whether the resources is saved or removed from the users's saved resources
  // If no, then moves user to the login page
  const handleToggleFavorite = (e) => {
    e.preventDefault();
    if (!user?.id) {
      navigate('/login');
      return;
    }

    //console.log(result._id);

    setIsFavorited(!isFavorited);
    updateUserFavorites(result._id, !isFavorited);

    //console.log(result._id);
    // Make the backend call to toggle favorite
    // fetch(`https://mycommunityfl.com/user/saveResourceToggle`, {
    fetch(`${API_BASE_LINK}/user/saveResourceToggle`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify({ userId: user.id, resourceId: result._id }),
    }).catch(error => console.error('Error saving entry:', error));
  };

  // Function to find URLs in text and make them clickable links
  // Input: Text that follows the URL regular expression
  // Output: Cleans and removes the matching text to replace it with the link
  const makeTextClickable = (text) => {
    if (!text) return text;

    // Enhanced regex to handle URLs in parentheses or with punctuation around them
    const urlPattern = /(?:\()?(https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.(com|org|net|gov|edu|info))(?:\))?/gi;

    return text.replace(urlPattern, (match) => {
      // Remove surrounding parentheses if they exist
      const cleanedMatch = match.replace(/[()]/g, "");
      const href = cleanedMatch.startsWith('http') ? cleanedMatch : `http://${cleanedMatch}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${cleanedMatch}</a>`;
    });
  };

  // Input: A specific set of text
  // Output: Makes the text a clickable link
  const createMarkup = (text) => {
    return { __html: makeTextClickable(text) };
  };

  // Function to generate Google Maps link for the address
  const getGoogleMapsLink = (address) => {
    const encodedAddress = encodeURIComponent(address); // Encode the address to be used in the URL
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  };

  return (
    <div className="search-result">
      <Link to={`/detail/${index}`} state={result} className="search-result-link">
        <h2>{result.Name}</h2>
      </Link>

      {/* Services */}
      {isValidField(result.Services) && (
        <p><strong>Services: </strong> <span dangerouslySetInnerHTML={createMarkup(result.Services)} /></p>
      )}

      {/* Eligibility Demographic */}
      {isValidField(result.Eligibility_Demographic) && (
        <p><strong>Eligibility Demographic: </strong> {result.Eligibility_Demographic}</p>
      )}

      {/* Phone */}
      {isValidField(result.Phone) && (
        <p><strong>Phone: </strong> {result.Phone}</p>
      )}

      {/* Address clickable link to Google Maps */}
      {isValidField(result.Address) && (
        <p><strong>Address: </strong> 
          <a href={getGoogleMapsLink(result.Address)} target="_blank" rel="noopener noreferrer">
            {result.Address}
          </a>
        </p>
      )}

      {/* Website */}
      {isValidField(result.Website) && (
        <p><strong>Website: </strong> <span dangerouslySetInnerHTML={createMarkup(result.Website || 'N/A')} /></p>
      )}

      {/* How to Apply */}
      {isValidField(result.How_To_Apply) && (
        <p><strong>How to Apply: </strong> <span dangerouslySetInnerHTML={createMarkup(result.How_To_Apply)} /></p>
      )}

      <div className="action-container">
        <label className="container" onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            checked={selected}
            onChange={handleCheckboxChange}
            id="AddToPDF"
          />
          <span className="checkmark"></span>Add to PDF
        </label>      
        <button className="save-button" onClick={handleToggleFavorite}>
          <img 
            src="/star.png" 
            alt="Favorite" 
            className={`save-icon ${isFavorited ? 'favorited' : ''}`} 
          />
        </button>
      </div>
    </div>
  );
};

export default SearchResult;
